import CompanyLanguagesDataTable from "../../../components/dataTable/tables/CompanyLanguagesDataTable";

function CompanyLanguagesPageView() {
  return <CompanyLanguagesDataTable />;
}

export default CompanyLanguagesPageView;
